import { useQuery } from "@tanstack/react-query";

import { userPushPreferencesQueryKey } from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UserPushPreferenceResponse } from "@/types";

export function useGetUserPushPreferences() {
  return useQuery({
    queryKey: userPushPreferencesQueryKey,
    queryFn: async () => {
      const path = "user-push-preferences";
      const res = await guacHttpClient.get<
        UserPushPreferenceResponse[],
        HttpResponse<UserPushPreferenceResponse[]>
      >(path);
      return res.data;
    },
  });
}
